import type { UseQueryOptions, UseQueryResult } from "react-query";
import { useQuery } from "react-query";

import type { GetUsPatientInsuranceArgs, GetUsPatientInsuranceResponse } from "api/types/GetUsPatientInsurance";
import { useApiClient } from "api/useApiClient";

export type UseGetUsPatientInsuranceQueryArgs = GetUsPatientInsuranceArgs;

type QueryKey = ["useGetUsPatientInsuranceQuery", UseGetUsPatientInsuranceQueryArgs];

export const getUsPatientInsuranceQueryKey = (args: UseGetUsPatientInsuranceQueryArgs): QueryKey => [
  "useGetUsPatientInsuranceQuery",
  args,
];

export const useGetUsPatientInsuranceQuery = (
  args: UseGetUsPatientInsuranceQueryArgs,
  options?: UseQueryOptions<GetUsPatientInsuranceResponse, Error, GetUsPatientInsuranceResponse, QueryKey>
): UseQueryResult<GetUsPatientInsuranceResponse, Error> => {
  const client = useApiClient();

  return useQuery(getUsPatientInsuranceQueryKey(args), () => client.getUsPatientInsurance(args), {
    cacheTime: Infinity,
    staleTime: Infinity,
    ...options,
  });
};
